import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiClient, ShareDetail } from '../api/client';
import { formatBytes } from '../lib/format';

export function SharePage() {
  const { code = '' } = useParams();
  const [share, setShare] = useState<ShareDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchShare() {
      try {
        const data = await apiClient.getShare(code);
        setShare(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : '无法加载分享');
      } finally {
        setLoading(false);
      }
    }

    fetchShare();
  }, [code]);

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-white/70">加载中…</div>;
  }

  if (error || !share) {
    return <div className="flex min-h-screen items-center justify-center text-white/70">{error ?? '分享不存在'}</div>;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle,_rgba(92,124,250,0.2),_transparent_70%)] p-6 text-white">
      <div className="glass-panel w-full max-w-xl rounded-3xl p-8">
        <p className="text-xs uppercase tracking-[0.5em] text-white/50">Share</p>
        <h1 className="text-3xl font-semibold">{share.file.name}</h1>
        <p className="text-sm text-white/60">{formatBytes(share.file.size)}</p>
        <div className="mt-6 flex flex-col gap-4 text-sm text-white/70">
          <button
            className="rounded-2xl bg-gradient-to-r from-brand to-accent py-3 text-base font-semibold"
            onClick={() => (window.location.href = `/raw/${share.code}`)}
          >
            立即下载
          </button>
          <button
            className="rounded-2xl border border-white/10 py-3 text-base"
            onClick={() => navigator.clipboard.writeText(window.location.href)}
          >
            复制分享链接
          </button>
        </div>
      </div>
    </div>
  );
}
